import { IcosClassDirective } from './class.directive'

export {
  IcosClassDirective,
}
